// apps/client/src/game/testFinders/items.ts (M1-T13) — `__wt.find('groundItem')`: the dropped item nearest `near`.
import type { TestFinder } from '../testHooks';
import { itemsLayerOf } from '../../world/items';
export const finders: readonly TestFinder[] = [{
  kind: 'groundItem',
  find(game, near) {
    const items = (itemsLayerOf(game)?.items() ?? []).filter((i) => i.at.loc === 'outdoors' && !i.at.placed);
    const d = (i: (typeof items)[number]) => (i.at.loc === 'outdoors' && near ? Math.hypot(i.at.x - near.x, i.at.y - near.y) : 0);
    const best = items.sort((a, b) => d(a) - d(b))[0];
    return best && best.at.loc === 'outdoors' ? { id: best.id, x: best.at.x + 0.5, y: best.at.y + 0.5 } : null;
  },
}];
